import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

import { ORDER_CACHE_KEYS } from "./keys";

import { OrderRepository } from "@/repositories/order";

export const useDeleteOrder = () => {
  const queryClient = useQueryClient();
  const orderRepository = useRef(new OrderRepository());

  return useMutation({
    mutationFn: async (orderId: string) => {
      return orderRepository.current.deleteOrder(orderId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ORDER_CACHE_KEYS.LIST({}) });
    },
  });
};
